module.exports = {"short":"pt_pt","long":"Portuguese (Portugal)","createdBy":"SaraVieira"}


//////////////////
// WEBPACK FOOTER
// ./store/pt_pt/meta.json
// module id = P/8C
// module chunks = 1